export var raRbacLanguageFrench = {
    'ra-rbac': {
        page: {
            unauthorized: 'Non autorisé',
        },
        message: {
            unauthorized: "Vous n'êtes pas autorisé à accéder à cette page",
        },
    },
};
